// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricing-table {
  border-radius: 20px;
  width: 83.5%;
  border: 2px solid var(--border);
  margin-top: 30px;
  overflow: hidden;
}
.pricing-table-container {
  border-collapse: collapse;
  width: 100%;
}
.pricing-table tr {
  text-align: justify;
}

.pricing-table thead th {
  padding: 20px 27px;
  background: var(--grey);
  width: 21.5%;
}
.pricing-table-container thead th:nth-child(2) {
  width: 21.5%;
}
.pricing-table tfoot td {
  padding: 30px 27px;
  border-top: 1px solid var(--border);
}

.pricing-table tbody td {
  padding: 3px 27px;
}

.pricing-table thead th .number {
  line-height: 22px !important;
}

.pricing-table thead th .number,
.pricing-table tbody td {
  font-size: 14px;
  font-weight: 400;
  line-height: 56px;
  text-align: left;
}

.table-heading {
  position: absolute;
  top: 112px;
}
.pricing-table-container .column-one {
  width: 58%;
  /* width: 85%; */
  line-height: 20px;
}
.pricing-table-container tfoot td:nth-child(1) {
  width: 58%;
  /* width: 85%; */
}
.total-heading {
  padding: 0px !important;
  background: var(--white) !important;
}
.total-heading .table-heading {
  top: -46px;
  padding-left: 27px;
}
.total-heading.hide {
  width: 57.5%;
}
.total-amount tfoot {
  font-size: 16px;
  font-weight: 800;
}
`, "",{"version":3,"sources":["webpack://./src/components/billTable/billTable.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".pricing-table {\n  border-radius: 20px;\n  width: 83.5%;\n  border: 2px solid var(--border);\n  margin-top: 30px;\n  overflow: hidden;\n}\n.pricing-table-container {\n  border-collapse: collapse;\n  width: 100%;\n}\n.pricing-table tr {\n  text-align: justify;\n}\n\n.pricing-table thead th {\n  padding: 20px 27px;\n  background: var(--grey);\n  width: 21.5%;\n}\n.pricing-table-container thead th:nth-child(2) {\n  width: 21.5%;\n}\n.pricing-table tfoot td {\n  padding: 30px 27px;\n  border-top: 1px solid var(--border);\n}\n\n.pricing-table tbody td {\n  padding: 3px 27px;\n}\n\n.pricing-table thead th .number {\n  line-height: 22px !important;\n}\n\n.pricing-table thead th .number,\n.pricing-table tbody td {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 56px;\n  text-align: left;\n}\n\n.table-heading {\n  position: absolute;\n  top: 112px;\n}\n.pricing-table-container .column-one {\n  width: 58%;\n  /* width: 85%; */\n  line-height: 20px;\n}\n.pricing-table-container tfoot td:nth-child(1) {\n  width: 58%;\n  /* width: 85%; */\n}\n.total-heading {\n  padding: 0px !important;\n  background: var(--white) !important;\n}\n.total-heading .table-heading {\n  top: -46px;\n  padding-left: 27px;\n}\n.total-heading.hide {\n  width: 57.5%;\n}\n.total-amount tfoot {\n  font-size: 16px;\n  font-weight: 800;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
